


import AtomButton from '../atoms/AtomButton.vue';
import AtomImage from '../atoms/AtomImage.vue';
import MoleculeContentBlock from '../molecules/MoleculeContentBlock.vue';
import {computed, defineComponent, onMounted, ref} from "@vue/composition-api";
import {useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: "ExplanationComponent",
  components: {
    AtomButton,
    AtomImage,
    MoleculeContentBlock
  },
  setup: () => {
    const store = useStore()
    const studyInspiratorExplanation = ref()

    onMounted(() => {
      studyInspiratorExplanation.value.focus()
    });

    return {
      studyInspiratorExplanation,
      labels: computed(() => store.getters.labels),
      toggleExplanation: () => store.commit('toggleExplanation'),
      explanationViewModel: computed(() => store.getters.explanationViewModel),
    }
  }
})
